<template>
  <router-view />
</template>
<script>

export default {
  name: 'App',
  components: {
  },
  // mounted() {
  //   this.$cable.connection.disconnect();
  //   this.$cable.connection.connect();
  // },
}
</script>

<style>
@import '@/assets/css/base.scss';
#app {
  font-family: 'Inter', 'Segoe UI', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111827;
  letter-spacing: -0.01em;
}

/* Smooth Scrolling */
* {
  scroll-behavior: smooth;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%);
  border-radius: 10px;
  
  &:hover {
    background: linear-gradient(135deg, #2563EB 0%, #7C3AED 100%);
  }
}

/* Selection Color */
::selection {
  background: rgba(59, 130, 246, 0.2);
  color: #1F2937;
}

::-moz-selection {
  background: rgba(59, 130, 246, 0.2);
  color: #1F2937;
}
</style>
